import { render, staticRenderFns } from "./NavigationMenuItemsList.vue?vue&type=template&id=a485751e"
import script from "./NavigationMenuItemsList.vue?vue&type=script&lang=js"
export * from "./NavigationMenuItemsList.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuItemsList.vue?vue&type=style&index=0&id=a485751e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports